import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
}

const ManualInformationModal: React.FC<Props> = props => {
  const { isOpen, onClose, onSave } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="448px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        padding={8}
        gap={6}
        bgColor="surfacePrimaryFill"
        flexDirection="column"
        borderRadius="base"
      >
        <Flex flexDirection="column">
          <FontAwesomeIcon fontSize="40px" icon={faTriangleExclamation} />
        </Flex>
        <Flex gap={2} flexDirection="column" textAlign="center">
          <Text textStyle="headingGroup">Add Information Manually?</Text>
          <Text alignItems="flex-start">
            If you skip the extraction step, you will have to manually enter
            submission and author information. Are you sure you want to proceed?
          </Text>
        </Flex>
        <Flex
          gap={2}
          flexDirection="column"
        >
          <Button variant="secondary" onClick={onClose} borderRadius="small">
            Cancel
          </Button>
          <Button variant="primary" onClick={onSave} borderRadius="small">
            Proceed
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ManualInformationModal;
